import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/client-providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/commboxScripts/CommboxScripts.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/shopFeatures/continuePurchase/ContinuePurchase.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/layout/Layout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/lib/mui-cache-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/lib/registry.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/swiper/swiper-bundle.min.css");
;
import(/* webpackMode: "eager" */ "/app/theme/global.css");
